/**
 * The Watchdog's colour rule: up only when rising AND above zero, down only when
 * falling AND below zero, neutral otherwise. A rising bar below zero is neutral.
 */
export function histogramTone(value: number, previous: number | undefined): 'up' | 'down' | 'flat' {
  if (previous === undefined) return 'flat';
  if (value > previous && value > 0) return 'up';
  if (value < previous && value < 0) return 'down';
  return 'flat';
}
